module.exports = __webpack_public_path__ + "static/media/live10_07_2021.793a4cef.jpg";